import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { locationsList, shelfStatusBulkList, userLocationList } from '../../../web_api/models';
import getLocations from '../../../web_api/methods/settings/locations/getLocations';
import { demoLocationsList } from '../../QueueManagement/demoAvgCashRegisterOpen';
import bakeryShelfCurrentStatusBulk from '../../../web_api/methods/bakeryDash/shelfCurrentStatusBulk';
import { LocationStatusInBulk } from './LocationStatusInBulk';
import LoadingPage from '../../../layout/LoadingPage';
import bakeryShelfCurrentStatusBulkPagination from '../../../web_api/methods/bakeryDash/shelfCurrentStatusBulkPagination';
import CommonPagination from '../../Common/CommonPagination';

export default function LocationsBakeryBulk() {
  const userList = useSelector((state: RootState) => state.userList);
  const selectedUser = useSelector((state: RootState) => state.selectedUser);
  const searchTextFilter = useSelector((state: RootState) => state.toolbarSearchFilter);
  const toolbarDateFilter = useSelector((state: RootState) => state.toolbarDateFilter);

  const [locations, setLocations] = useState<locationsList>(demoLocationsList);
  const [loadLocationsFrom, setLoadLocationsFrom] = useState<locationsList | userLocationList>([]);
  const [filteredLocations, setFilteredLocations] = useState<locationsList | userLocationList>([]);
  const username = useSelector((state: RootState) => state.user.user_name);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);

  const [bakeryCurrentStatus, setBakeryCurrentStatus] = useState<shelfStatusBulkList>([]);

  const isDemoUser = username.includes('demo');

  useEffect(() => {
    const debounceTimeout = 300;
    const handler = setTimeout(() => {
      loadLocations();
    }, debounceTimeout);

    return () => clearTimeout(handler);
  }, [toolbarDateFilter.date, page, searchTextFilter.searchText, selectedUser.id]);

  useEffect(() => {
    setPage(0);
  }, [searchTextFilter.searchText]);

  useEffect(() => {
    if (selectedUser.id === '0') {
      setLoadLocationsFrom(locations);
    } else setLoadLocationsFrom(userList.list.find((x) => x.id === selectedUser.id)?.locations!);
  }, [selectedUser]);

  const loadLocations = async () => {
    try {
      setLoading(true);
      let loadedLocations: locationsList = isDemoUser ? demoLocationsList : await getLocations();
      setLocations(loadedLocations);
      if (selectedUser.id === '0') {
        setLoadLocationsFrom(loadedLocations);
      } else setLoadLocationsFrom(userList.list.find((x) => x.id === selectedUser.id)?.locations!);

      await bakeryShelfCurrentStatusBulkPagination(selectedUser.id, new Date(toolbarDateFilter.date), page, 30, searchTextFilter.searchText).then((bakeryRes) => {
        setBakeryCurrentStatus(bakeryRes);
        setHasNextPage(bakeryRes.length > 0 && bakeryRes[0].has_next_page);
        setLoading(false);
      });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (searchTextFilter.searchText === '') {
      setFilteredLocations(loadLocationsFrom);
      return;
    }
    setFilteredLocations(loadLocationsFrom.filter((location) => location.name.toLowerCase().includes(searchTextFilter.searchText.toLowerCase())));
    console.log({ filteredLocations });
  }, [loadLocationsFrom, searchTextFilter]);

  return (
    <div className='row'>
      {loading ?
          <LoadingPage /> 
          : 
          <>
            <div className='w-100 d-flex flex-row align-items-center justify-content-end'>
              <CommonPagination
              disableNext={!hasNextPage}
              disablePrevious={page === 0}
              handleNextChange={() => {
                setPage(page + 1);
              }}
              handlePrevChange={() => {
                setPage(page - 1);
              }}
              startIndex={page + 1}
              // containerClass='mb-3 w-100 d-flex flex-row align-items-end justify-content-center'
              />
            </div>
            <div className='row min-h-800px'>
              {filteredLocations.length > 0 ? filteredLocations.map((item, index) => (
                <LocationStatusInBulk key={item.id} locationId={item.id} locationName={item.name} className='animated zoomIn' delay={`0.${index + 1}s`} shelfStatus={bakeryCurrentStatus.filter((status) => status.location_id === item.id)} />
              )): (
                <div className='col-12 text-center my-5'>
                  <h5 className='text-muted'>No locations found</h5>
                </div>
              )}
            </div>
            <div className='w-100 d-flex flex-row align-items-center justify-content-end'>
              <CommonPagination
              disableNext={!hasNextPage}
              disablePrevious={page === 0}
              handleNextChange={() => {
                setPage(page + 1);
              }}
              handlePrevChange={() => {
                setPage(page - 1);
              }}
              startIndex={page + 1}
              // containerClass='mb-3 w-100 d-flex flex-row align-items-end justify-content-center'
              />
            </div>
          </>
        }
    </div>
  );
}
